import type { AiMaturityContent } from '../fr/aiMaturity';

export const AI_MATURITY: AiMaturityContent = {
  label: 'AI practice',
  title: 'Where I stand on Boris Cherny’s ladder',
  paragraphs: [
    'On July 16, 2026, Boris Cherny — the creator of Claude Code at Anthropic — published a five-level ladder describing how developers adopt AI agents. It measures one thing: how much of the work you are willing to delegate. At the bottom, a human reads every line the machine produces; as you climb, manual supervision is replaced by a verification system — tests, isolated environments, automated review — that lets ever more agents work in parallel. At every step, the bottleneck is never motivation: it is that system you have to build.',
    'My Claude Code setup puts me between steps 2 and 3: several agents running in parallel, each in its own isolated environment, a verification loop the agent runs itself — typecheck, lint, build — and a review that looks at results, no longer at keystrokes.',
  ],
  levels: [
    { value: 0, name: 'Locked access',    caption: 'The tool is bought, the processes block it' },
    { value: 1, name: 'The pair',         caption: 'One human, one agent, everything supervised' },
    { value: 2, name: 'The orchestrator', caption: 'Agents in parallel, reviewing final results' },
    { value: 3, name: 'The hundred',      caption: 'No more line-by-line supervision' },
    { value: 4, name: 'Intent',           caption: 'A thousand agents, steering by pure intent' },
  ],
  position: 2.5,
  markerLabel: 'Here — 2 → 3',
  sourceNote: 'Ladder published by Boris Cherny (Anthropic), July 2026.',
};
